import React from "react";
import ImageGallery from "../components/ImageGallery";

function PortraitPage() {
  return <ImageGallery category="portrait" />;
}

export default PortraitPage;
